<template>
  <div class="CompanyProfile">
    <h2>近期项目</h2>
    <div class="heng"></div>
    <div class="photoList">
      <ul>
        <li
          @mouseover="active = index"
          @mouseout="active = -1"
          v-for="(item, index) of photoList"
          :key="index"
        >
          <div :class="active == index ? 'mark active' : 'mark'"></div>
          <img :src="item.src" alt="" />
          <div
            :class="active == index ? 'project_msg' : 'project_msg unactive'"
          >
            <h3>{{ item.date }}</h3>
            <h4>{{ item.name }}</h4>
            <img src="../../public/img/project_detail.png" alt="" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "CompanyProject",
  title: "项目",
  data() {
    return {
      active: -1,
      photoList: [
        {
          name: "海底捞四川成都东部新区总部基地建设前期资源调查项目",
          date: "2021.1.3",
          src: require("../../public/img/20210103.png"),
        },
        {
          name: "川西北沙化土地治理成效监测",
          date: "2021.4.20",
          src: require("../../public/img/20190420.png"),
        },
        {
          name: "森林资源年度“双增”项目",
          date: "2021.11.8",
          src: require("../../public/img/20201108.png"),
        },
        {
          name: "德格县林业和草原局第六次全国沙化监测项目",
          date: "2021.4.21",
          src: require("../../public/img/20200421.png"),
        },
        {
          name: "沐川县森林督察暨林地一张图",
          date: "2021.5.10",
          src: require("../../public/img/20200510.png"),
        },
        {
          name: "四川永丰浆纸股份有限公司...",
          date: "2021.6.8",
          src: require("../../public/img/20200608.png"),
        },
        {
          name: "森林资源监测体系建设项目",
          date: "2021.10.8",
          src: require("../../public/img/20201008.png"),
        },
      ],
    };
  },
  methods: {
    mouseIn(num) {
      this.active = num;
    },
  },
};
</script>
<style lang="scss" scoped>
div.CompanyProfile {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  padding-top: 54px;
  h2 {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 1.75rem;
  }
  div.heng {
    width: 34px;
    border-bottom: 2px solid #00be92;
    margin: 10px auto;
    margin-bottom: 38px;
  }
  div.photoList {
    width: 1200px;
    margin: 0 auto;
    ul > li {
      float: left;
      position: relative;
      margin-bottom: 25px;
      cursor: pointer;
      overflow: hidden;

      div.mark {
        height: 100%;
        width: 100%;
        position: absolute;
        background: linear-gradient(
          180deg,
          rgba(141, 140, 140, 0.08) 40%,
          rgba(0, 0, 0, 0.86) 100%
        );
        top: 100%;
        z-index: 5;
      }
      .mark.active {
        top: 0;
      }
      img {
        transition: all 0.6s ease 0s;
        display: block;
      }
      div.project_msg {
        position: absolute;
        font-family: Source Han Sans CN;
        color: #ffffff;
        font-size: 1.5rem;
        line-height: 1.5rem;
        left: 28px;
        z-index: 10;
        text-align: left;
        bottom: -20px;
        h4 {
          margin-top: 8px;
          margin-bottom: 28px;
          font-weight: 400;
        }
        img{
          visibility: visible;
          
        }
      }
    }
    li:nth-child(odd) {
      margin-right: 25px;
    }
    li:nth-child(6) {
      margin-right: 25px;
    }
    li:nth-child(7) {
      margin-right: 0;
    }
    li:hover > img {
      transform: scale(1.1);
      transition: all 0.6s ease 0s;
    }
    @-webkit-keyframes msgmove {
      from {
        bottom: -20px;
      }
      to {
        bottom: 36px;
      }
    }
    @-webkit-keyframes msgmoveout {
      from {
        bottom: 36px;
      }
      to {
        bottom: -20px;
      }
    }
    li:hover .project_msg {
      animation: msgmove 0.6s ease;
      animation-fill-mode: forwards;
    }
    .project_msg.unactive {
      animation: msgmoveout 0.4s ease;
      animation-fill-mode: forwards;
      img{
        visibility: hidden;
      }
    }
  }
}
</style>
